import { render, staticRenderFns } from "./TourStep.vue?vue&type=template&id=0cc8ba16"
import script from "./TourStep.vue?vue&type=script&lang=js"
export * from "./TourStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports